import React, { useState, useEffect, useContext, useRef } from "react";
import Card from "react-bootstrap/Card";
import { FaRegCopy, FaRegUser, FaUser } from "react-icons/fa";
import ListGroup from "react-bootstrap/ListGroup";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { MdBackspace } from "react-icons/md";
import { AuthContext } from "../../context/AuthContext";
import { PlantsContext } from "../../context/PlantsContext";
import Loading from "../../pages/Loading";
import { copyToClipboard } from "../../utils/utils";
import { MapContainer, TileLayer, useMap, Popup, Marker } from "react-leaflet";

import PlantFormSelect from "./PlantFormSelect";
import logo from "../../assets/images/ti pianto per amore-APP-verde.png";
import markerBlue from "../../assets/images/ti pianto per amore-APP-azzurro.png";
import markerGreen from "../../assets/images/ti pianto per amore-APP-verde.png";
import markerOrange from "../../assets/images/ti pianto per amore-APP-giallo.png";
import markerRed from "../../assets/images/ti pianto per amore-APP-rosso.png";
import L from "leaflet";
import ApprovedPic from "./ApprovedPic";
import Buttons from "../map/Buttons";
import ButtonDirection from "../map/ButtonDirection";
import { UsersContext } from "../../context/UsersContext";

const InfoCard = () => {
  const [showPic, setShowPic] = useState(false);
  const handleShowPic = () => setShowPic(true);
  const handleClosePic = () => setShowPic(false);
  const { plantId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { loggedUserInfo } = useContext(UsersContext);
  const {
    plant,
    userInfo,

    getReporterInfo,
    getOwnerInfo,
    reporterInfo,
    ownerInfo,
    request,
  } = useContext(PlantsContext);
  console.log("USER INFO", loggedUserInfo);
  const fromPage = location.state?.from || "/map";
  const fileInputRef = useRef(null);
  const {
    getSinglePlant,
    singlePlantError,
    handleStatusChange,
    deletePlant,
    singlePlantLoading,
    handlePlateUpload,
    plateUrl,
    plateLoading,
    handlePlateRemoval,
    modalUserShow,
    setModalUserShow,
  } = useContext(PlantsContext);
  const backToMap = () => {
    navigate(fromPage);
  };

  // if (singlePlantLoading) return <Loading />;
  // if (singlePlantError) return <div className='error'>{singlePlantError}</div>;
  // if (!plant) return <div>No plant found.</div>;
  const {
    lat,
    lang,
    image_url,
    status_piantina,
    rejection_comment,
    user_comment,
    plant_type,
    city,
    suburb,
    road,
    residential,
    shop,
    house_number,
    plate,
    plate_hash,
    delete_hash,
    user_id,
  } = plant;
  useEffect(() => {
    getSinglePlant(plantId);
  }, [plantId, plateUrl, lat, lang]);

  const iconBlue = L.icon({ iconUrl: markerBlue, iconSize: [25, 42] });
  const iconGreen = L.icon({ iconUrl: markerGreen, iconSize: [25, 42] });
  const iconOrange = L.icon({ iconUrl: markerOrange, iconSize: [25, 42] });
  const iconRed = L.icon({ iconUrl: markerRed, iconSize: [25, 42] });
  const booked = status_piantina === "booked";
  const approved = status_piantina === "approved";
  const pending = status_piantina === "pending";
  const rejected = status_piantina === "rejected";
  const markerIcon = booked
    ? iconBlue
    : approved
      ? iconGreen
      : pending
        ? iconOrange
        : iconRed;
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const deleteAndGo = async (plantId) => {
    // setSinglePlantLoading(true);

    try {
      await deletePlant(plantId);
    } catch (err) {
      console.log(err);
      // setSinglePlantLoading(false);
    } finally {
      navigate("/map");
      // setSinglePlantLoading(false);
    }
  };
  return (
    <>
      {showPic && (
        <ApprovedPic
          showPic={showPic}
          handleClosePic={handleClosePic}
          img={image_url}
        />
      )}
      <Card
        className={
          approved
            ? "flex-md-row card-plant-info-approved"
            : "flex-md-row card-plant-info1"
        }
      >
        <ListGroup className='list-group-flush'>
          {(status_piantina === "rejected" ||
            status_piantina === "pending") && (
            <ListGroup.Item>
              <span className='fw-medium'>Segnalatore:</span>{" "}
              <span>{userInfo ? userInfo : "utente rimosso"}</span>
            </ListGroup.Item>
          )}
          <ListGroup.Item>
            {" "}
            <span className='fw-medium'>Città:</span> <span>{city}</span>
          </ListGroup.Item>
          <ListGroup.Item>
            {" "}
            <span className='fw-medium'>Quartiere:</span> <span>{suburb}</span>
          </ListGroup.Item>
          {road !== "undefined" && (
            <ListGroup.Item>
              {" "}
              <span className='fw-medium'>Indirizzo:</span> <span>{road}</span>
            </ListGroup.Item>
          )}
          {image_url && (
            <ListGroup.Item>
              {" "}
              <span className='fw-medium'>Foto:</span>{" "}
              <span
                className='page-link d-inline'
                type='button'
                onClick={handleShowPic}
              >
                apri immagine
              </span>
            </ListGroup.Item>
          )}
          <ListGroup.Item>
            {" "}
            <span className='fw-medium'>Riferimento:</span>{" "}
            <span>Zolla &#8470; {plantId}</span>
          </ListGroup.Item>
          {shop !== "undefined" && (
            <ListGroup.Item>
              {" "}
              <span>Negozio:</span> <span>{shop}</span>
            </ListGroup.Item>
          )}
          {residential !== "undefined" && (
            <ListGroup.Item>
              {" "}
              <span className='fw-medium'>Residenza:</span>{" "}
              <span>{residential}</span>
            </ListGroup.Item>
          )}
          {house_number !== "undefined" && (
            <ListGroup.Item>
              {" "}
              <span className='fw-medium'>Numero civico:</span>{" "}
              <span>{house_number}</span>
            </ListGroup.Item>
          )}
          {status_piantina === "pending" ||
            (status_piantina === "rejected" && (
              <ListGroup.Item>
                {" "}
                <span className='fw-medium'>Stato:</span>{" "}
                <span
                  className={
                    status_piantina === "approved"
                      ? "approvedPlant"
                      : status_piantina === "rejected"
                        ? "rejectedPlant"
                        : status_piantina === "booked"
                          ? "bookedPlant"
                          : "pendingPlant"
                  }
                >
                  {status_piantina === "pending"
                    ? "in attesa di approvazione"
                    : status_piantina === "approved"
                      ? "approvata"
                      : status_piantina === "rejected"
                        ? "non approvata"
                        : status_piantina === "booked"
                          ? "acquistata"
                          : status_piantina}
                </span>
              </ListGroup.Item>
            ))}
          {plant_type && status_piantina === "pending" && (
            <ListGroup.Item>
              <span className='fw-medium'>Tipo di pianta:</span>{" "}
              <span>{plant_type}</span>
            </ListGroup.Item>
          )}
          {/* {userRole === "admin" && (
            <ListGroup.Item>
              {" "}
              <span className='fw-medium'>Direzioni:</span>{" "}
              <a className='circle-button report-btn p-0'>
                Navigazione su Google Maps
              </a>
            </ListGroup.Item>
          )} */}
          <ListGroup.Item>
            {" "}
            <span className='fw-medium'>Coordinate:</span>{" "}
            <span
              className='copy'
              onClick={() => copyToClipboard([`${lat},${lang}`])}
            >
              {lat} / {lang} <FaRegCopy className='copy-icon' />
            </span>
          </ListGroup.Item>

          {status_piantina === "rejected" && (
            <ListGroup.Item>
              {" "}
              <span className='fw-medium'>Motivazione:</span>{" "}
              <span>{rejection_comment}</span>
            </ListGroup.Item>
          )}
        </ListGroup>
        <article className='booked-position-map'>
          <MapContainer
            center={[lat, lang]}
            zoom={17}
            dragging={false}
            scrollWheelZoom={false}
            zoomControl={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url='https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
            />

            <Marker
              eventHandlers={{
                click: () => {
                  handleShowPic();
                },
              }}
              icon={markerIcon}
              position={[lat, lang]}
              scrollWheelZoom={false}
              zoomControl={false}
            ></Marker>
            {/* {loggedUserInfo?.email === "franekdev86@gmail.com" && (
              <ButtonDirection />
            )} */}
          </MapContainer>
        </article>
      </Card>
    </>
  );
};

export default InfoCard;
